import { useQuery } from 'react-query';
import { getQueryKeys } from './queryKeys';
import request from '../../../helpers/request';

const getRequestAttachment = async ({ requestId, fileName }) => {
  const res = await request.get(
    `/Request/attachment`,
    { requestId, fileName },
    'Не удалось загрузить файл'
  );

  return res;
};

const useAttachmentUrl = ({ requestId, fileName }, options) => {
  return useQuery(
    getQueryKeys.attachmentUrl(requestId, fileName),
    () => getRequestAttachment({ requestId, fileName }),
    { staleTime: Infinity, ...options }
  );
};

export default useAttachmentUrl;
